exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropbox{outline:2px dashed grey;outline-offset:-10px;background:#bfbfbf;color:#000;padding:10px;min-height:200px;position:relative;cursor:pointer}.input-file{opacity:0;width:100%;height:200px;position:absolute;cursor:pointer}.dropbox:hover{background:#a5a5a5}.dropbox p{font-size:1.2em;text-align:center;padding:50px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-189206ef","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User/import.vue
// module id = 500
// module chunks = 0